import React from 'react'
import { determineColor } from '../../util/color.js'
import { money, percentage } from '../../util/formatters.js'
import { Calculation } from './Calculation'
import { MarketplaceI } from '../../util/marketplaces.js'
import { calculate } from './AcosCellCalcs.js'

export interface AcosCellProps {
    acos: number
    target_acos?: number
    default_target_acos: number
    cost: number
    marketplace?: MarketplaceI
    version: number
}

export const AcosCell = ({
    acos,
    target_acos,
    default_target_acos,
    cost,
    marketplace,
    version,
}: AcosCellProps) => {
    const {
        acos: acosFormatted,
        spend: spendFormatted,
        sales: salesFormatted,
        color,
    } = calculate({
        acos,
        target_acos,
        default_target_acos,
        cost,
        marketplace,
        version,
    })

    const lines = [
        { description: 'Spend', value: spendFormatted },
        { description: '÷ Sales', value: salesFormatted },
        { description: 'ACOS', value: acosFormatted },
    ]

    return (
        <Calculation lines={lines}>
            <div className={color}>{acosFormatted}</div>
        </Calculation>
    )
}

export const BlendedAcosCell = ({
    acos,
    target_acos,
    default_target_acos,
    cost,
    marketplace,
}: Omit<AcosCellProps, 'roas'>) => {
    const target = (target_acos || default_target_acos) / 100
    const color = determineColor(acos, target, cost)
    const m = marketplace ?? null

    const lines = [
        { description: 'Spend', value: money(cost, m) ?? '' },
        { description: '÷ Blended Profit', value: money((cost / acos) * 100, m) ?? '' },
        { description: 'Blended ACOS', value: percentage(acos) ?? '' },
    ]

    return (
        <Calculation lines={lines}>
            <div className={color}>{percentage(acos)}</div>
        </Calculation>
    )
}
